var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import * as React from "react";
import { useEffect, useState } from "react";
import { useRecordContext } from "react-admin";
import { useDataProvider, useResourceContext, useNotify, useRefresh, } from "react-admin";
import { useMediaQuery, Typography, Grid, Button, IconButton, Dialog, DialogContent, Zoom, CircularProgress, Tooltip, Box, } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { dialog } from "../../utils/componentWizard";
import { pdfjs } from "react-pdf";
import { GradableImageGrid, UngradableImageGrid } from "./GradImgGrid";
import { Droppable } from "./dragAndDrop/Droppable";
import { DndContext } from "@dnd-kit/core";
import { styles } from "./helper/FPstyles";
import { LoadingAnimation } from "../../utils/loadingAnimation";
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");
import { updateAnalyzedResultTextCases, removeDuplicateCommentRows, } from "./helper/FPhelper";
import popupStyles from "../../styles/popup/popup.module.css";
import { SecureImage } from "../../utils/imageUrlChecker";
var downloadURI = function (uri, name) {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
var Transition = React.forwardRef(function Transition(props, ref) {
    return _jsx(Zoom, __assign({ ref: ref }, props));
});
//[1120] [back] do: tab size instead of mobile size
var FPComp = function (_a) {
    var _b;
    var filters = _a.filters, setFilters = _a.setFilters, onLoaded = _a.onLoaded, image = _a.image, setImage = _a.setImage, imageInfos = _a.imageInfos, setImageInfos = _a.setImageInfos, analyzedResultInfo = _a.analyzedResultInfo, analyzedImagesData = _a.analyzedImagesData, isLoading = _a.isLoading, handleUploadedImages = _a.handleUploadedImages, setAnalyzedResultInfo = _a.setAnalyzedResultInfo, setCurrentSubjectSection = _a.setCurrentSubjectSection, curRowImgs = _a.curRowImgs, setCurRowImgs = _a.setCurRowImgs, currentImgUploadRow = _a.currentImgUploadRow, selectedRow = _a.selectedRow, setIsLoadingUpload = _a.setIsLoadingUpload, isLoadingUpload = _a.isLoadingUpload, setDummyCompList = _a.setDummyCompList, translate = _a.translate, setIsLoadingFPAI = _a.setIsLoadingFPAI, setLoadingFPAITime = _a.setLoadingFPAITime, isLoadingFPAI = _a.isLoadingFPAI, loadingFPAITime = _a.loadingFPAITime, getACL = _a.getACL, gens = _a.gens, accessControlList = _a.accessControlList, props = __rest(_a, ["filters", "setFilters", "onLoaded", "image", "setImage", "imageInfos", "setImageInfos", "analyzedResultInfo", "analyzedImagesData", "isLoading", "handleUploadedImages", "setAnalyzedResultInfo", "setCurrentSubjectSection", "curRowImgs", "setCurRowImgs", "currentImgUploadRow", "selectedRow", "setIsLoadingUpload", "isLoadingUpload", "setDummyCompList", "translate", "setIsLoadingFPAI", "setLoadingFPAITime", "isLoadingFPAI", "loadingFPAITime", "getACL", "gens", "accessControlList"]);
    var AnalyzedResultPreInfoIcon = analyzedResultInfo === null || analyzedResultInfo === void 0 ? void 0 : analyzedResultInfo["icon"];
    var analyzedResultInfoIcon = AnalyzedResultPreInfoIcon ? (_jsx(AnalyzedResultPreInfoIcon, { style: { width: "17px", height: "17px" } })) : null;
    var _c = useState(false), openImage = _c[0], setOpenImage = _c[1];
    var _d = useState(""), openImageURL = _d[0], setOpenImageURL = _d[1];
    var _e = useState(false), canAnalyze = _e[0], setCanAnalyze = _e[1]; //conditions to check if an analyze
    //the modified curRowImgs
    var _f = useState({
        update: [],
        comment: [],
        delete: [],
    }), modifiedCurRowImgs = _f[0], setModifiedCurRowImgs = _f[1]; //fpOneUpdate, fpOneDelete
    var _g = useState([]), modifiedCurrentImgUploadRow = _g[0], setModifiedCurrentImgUploadRow = _g[1]; //updateAttribute
    var _h = useState({
        center: [],
        notCenter: [],
    }), idxArrForGrid = _h[0], setIdxArrForGrid = _h[1];
    // is dragging or not
    var _j = useState(false), isDragging = _j[0], setIsDragging = _j[1];
    // Track if there are unsaved changes
    var _k = useState(false), hasUnsavedChanges = _k[0], setHasUnsavedChanges = _k[1];
    var _l = useState(false), isAnalyzing = _l[0], setIsAnalyzing = _l[1];
    var dataProvider = useDataProvider();
    var resource = "exams";
    var record = useRecordContext(props);
    var res = useResourceContext();
    var notify = useNotify();
    var refresh = useRefresh();
    var isTabScreen = useMediaQuery("(max-width: 1030px)");
    var _m = useState(false), openAnalyzeDialog = _m[0], setOpenAnalyzeDialog = _m[1];
    var _o = useState("language"), analyzeDialogStep = _o[0], setAnalyzeDialogStep = _o[1];
    var _p = useState(null), selectedLanguage = _p[0], setSelectedLanguage = _p[1];
    var _q = useState(false), openConfirmDialog = _q[0], setOpenConfirmDialog = _q[1];
    var canCreateDetailedReport = !!((_b = accessControlList === null || accessControlList === void 0 ? void 0 : accessControlList.operation) === null || _b === void 0 ? void 0 : _b.detailed_report);
    var analyzeTips = [
        "".concat(translate("pages.exam.fp.analyzeCases.cases")),
        "".concat(translate("pages.exam.fp.analyzeCases.both")),
        "".concat(translate("pages.exam.fp.analyzeCases.leftOnly")),
        "".concat(translate("pages.exam.fp.analyzeCases.rightOnly")),
    ];
    //update window sizes
    // document.body.style.zoom = "70%";
    document.body.style.background = "white";
    // handle drag drop action
    var handleDragEnd = function (item) {
        var _a;
        setIsDragging(false);
        // find the selected item from curRowImgs
        var selectedDragItemIdIndex = curRowImgs.findIndex(function (obj) { var _a; return obj.id === ((_a = item === null || item === void 0 ? void 0 : item.active) === null || _a === void 0 ? void 0 : _a.id); });
        var updatedCurRowImgs = JSON.parse(JSON.stringify(curRowImgs));
        setCurRowImgs([]);
        // api params
        var selectedDragItem = curRowImgs.find(function (obj) { var _a; return obj.id === ((_a = item === null || item === void 0 ? void 0 : item.active) === null || _a === void 0 ? void 0 : _a.id); });
        var params = {
            data: {},
        };
        // check what drag case
        switch ((_a = item === null || item === void 0 ? void 0 : item.over) === null || _a === void 0 ? void 0 : _a.id) {
            case null:
                setCurRowImgs(updatedCurRowImgs);
                return;
            //gradable
            case "center-left-eye":
                updatedCurRowImgs[selectedDragItemIdIndex].center = true;
                updatedCurRowImgs[selectedDragItemIdIndex].right = false;
                updatedCurRowImgs[selectedDragItemIdIndex].gradable = true;
                params.data = {
                    center: true,
                    right: false,
                    gradable: true,
                };
                break;
            case "center-right-eye":
                updatedCurRowImgs[selectedDragItemIdIndex].center = true;
                updatedCurRowImgs[selectedDragItemIdIndex].right = true;
                updatedCurRowImgs[selectedDragItemIdIndex].gradable = true;
                params.data = {
                    center: true,
                    right: true,
                    gradable: true,
                };
                break;
            case "not-center-left-eye":
                updatedCurRowImgs[selectedDragItemIdIndex].center = false;
                updatedCurRowImgs[selectedDragItemIdIndex].right = false;
                updatedCurRowImgs[selectedDragItemIdIndex].gradable = true;
                params.data = {
                    center: false,
                    right: false,
                    gradable: true,
                };
                break;
            case "not-center-right-eye":
                updatedCurRowImgs[selectedDragItemIdIndex].center = false;
                updatedCurRowImgs[selectedDragItemIdIndex].right = true;
                updatedCurRowImgs[selectedDragItemIdIndex].gradable = true;
                params.data = {
                    center: false,
                    right: true,
                    gradable: true,
                };
                break;
            //ungradable
            case "ungradable":
                updatedCurRowImgs[selectedDragItemIdIndex].gradable = false;
                params.data = {
                    gradable: false,
                };
                break;
            default:
                setCurRowImgs(updatedCurRowImgs);
                return;
        }
        setCurRowImgs([]);
        var eyeLabel = updateAnalyzedResultTextCases(updatedCurRowImgs, setAnalyzedResultInfo, translate);
        //api
        setIsLoadingUpload(true);
        // record modified cur image rows
        var updatedModifiedCurRowImgs = JSON.parse(JSON.stringify(modifiedCurRowImgs));
        var updatedModifiedCurrentImgUploadRow = JSON.parse(JSON.stringify(modifiedCurrentImgUploadRow));
        updatedModifiedCurRowImgs.update = updatedModifiedCurRowImgs.update.filter(function (entry) { return entry.id !== updatedCurRowImgs[selectedDragItemIdIndex].id; });
        updatedModifiedCurRowImgs.update.push({
            resource: resource,
            params: params,
            id: updatedCurRowImgs[selectedDragItemIdIndex].id,
        });
        setModifiedCurRowImgs(updatedModifiedCurRowImgs);
        setHasUnsavedChanges(true);
        setCurRowImgs(updatedCurRowImgs);
        setIsLoadingUpload(false);
        //update the eye label
        if (eyeLabel) {
            var editParams = {
                data: {
                    subject_customId: currentImgUploadRow.subject_customId,
                    eye: eyeLabel,
                },
            };
            updatedModifiedCurrentImgUploadRow = updatedModifiedCurrentImgUploadRow.filter(function (entry) { return entry.id !== currentImgUploadRow.id; });
            updatedModifiedCurrentImgUploadRow.push({
                resource: resource,
                params: editParams,
                subject_id: currentImgUploadRow.hkid_id,
                id: currentImgUploadRow.id,
            });
            setModifiedCurrentImgUploadRow(updatedModifiedCurrentImgUploadRow);
        }
    };
    //handle start drag
    var handleDragStart = function (id) {
        setIsDragging(true);
    };
    var updateIdxArrForGrid = function (givenCurRow) {
        var updatedIdxArrForGrid = JSON.parse(JSON.stringify(idxArrForGrid));
        givenCurRow.map(function (el, idx) {
            if (el.gradable && el.center) {
                updatedIdxArrForGrid.center.push(idx);
            }
            else if (el.gradable && !el.center) {
                updatedIdxArrForGrid.notCenter.push(idx);
            }
        });
        setIdxArrForGrid(updatedIdxArrForGrid);
    };
    useEffect(function () {
        setDummyCompList([
            { name: "AI Results", bgColor: "#efefef" },
            { name: "Data Import", bgColor: "white" },
        ]);
    }, [curRowImgs]);
    useEffect(function () {
        //check which result text case - on top
        updateAnalyzedResultTextCases(curRowImgs, setAnalyzedResultInfo, translate);
        // get the idx for gridding in gradable center / nonCenter
        updateIdxArrForGrid(curRowImgs);
    }, []);
    var handelImageGrid = function (idx, action, onChangeVal) {
        var updatedCurRowImgs = JSON.parse(JSON.stringify(curRowImgs));
        var cmtParams = {
            data: { comment: onChangeVal },
        };
        var updatedModifiedCurRowImgs = JSON.parse(JSON.stringify(modifiedCurRowImgs));
        switch (action) {
            case "cmt":
                updatedCurRowImgs[idx].comment = onChangeVal;
                updatedModifiedCurRowImgs.comment.push({
                    resource: resource,
                    params: cmtParams,
                    id: updatedCurRowImgs[idx].id,
                });
                setCurRowImgs(updatedCurRowImgs);
                setHasUnsavedChanges(true);
                break;
            case "delete":
                setCurRowImgs([]);
                updatedModifiedCurRowImgs.delete.push({
                    resource: resource,
                    id: updatedCurRowImgs[idx].id,
                });
                setIsLoadingUpload(false);
                updatedCurRowImgs.splice(idx, 1);
                setCurRowImgs(updatedCurRowImgs);
                updateAnalyzedResultTextCases(updatedCurRowImgs, setAnalyzedResultInfo, translate);
                setHasUnsavedChanges(true);
                //update idArr
                updateIdxArrForGrid(updatedCurRowImgs);
                break;
        }
        setModifiedCurRowImgs(updatedModifiedCurRowImgs);
    };
    var handleOpenImage = function (image) {
        setOpenImageURL(image);
        setOpenImage(true);
    };
    var handleCloseImage = function () {
        // close table image
        setOpenImageURL("");
        setOpenImage(false);
    };
    var resetAnalyzeDialog = function () {
        setOpenAnalyzeDialog(false);
        setAnalyzeDialogStep("language");
        setSelectedLanguage(null);
    };
    var handleLanguageSelect = function (language) {
        setSelectedLanguage(language);
        if (canCreateDetailedReport) {
            setAnalyzeDialogStep("reportType");
        }
        else {
            handleFPAIAnalyze(language, false);
        }
    };
    //handle AI analyze part — backend runs analysis, builds PDF, stores URL; response body is application/pdf
    var handleFPAIAnalyze = function (language_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([language_1], args_1, true), void 0, function (language, detailedReport) {
            var analysisResult, blob, pdfBlob, blobUrl_1, error_1, raw, msg;
            var _a;
            if (detailedReport === void 0) { detailedReport = false; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsAnalyzing(true);
                        setIsLoadingFPAI(true);
                        resetAnalyzeDialog();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, 6, 7]);
                        if (!hasUnsavedChanges) return [3 /*break*/, 3];
                        return [4 /*yield*/, handleSave()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        // Same as original: leave FP UI and show ExamList loading state while waiting for the PDF API
                        closeAndReset();
                        return [4 /*yield*/, dataProvider.triggerExamAnalysis({
                                data: {
                                    subjectId: currentImgUploadRow.subject_id,
                                    examId: currentImgUploadRow.id,
                                    language: language,
                                    detailedReport: detailedReport,
                                },
                            })];
                    case 4:
                        analysisResult = _b.sent();
                        blob = analysisResult.data.blob;
                        pdfBlob = blob.type === "application/pdf"
                            ? blob
                            : new Blob([blob], { type: "application/pdf" });
                        blobUrl_1 = URL.createObjectURL(pdfBlob);
                        window.open(blobUrl_1, "_blank", "noopener,noreferrer");
                        setTimeout(function () { return URL.revokeObjectURL(blobUrl_1); }, 120000);
                        refresh();
                        return [3 /*break*/, 7];
                    case 5:
                        error_1 = _b.sent();
                        console.error(error_1);
                        raw = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.message) !== null && _a !== void 0 ? _a : String(error_1);
                        msg = raw.replace(/^HttpError2:\s*/, "").trim();
                        if (raw === "HttpError2: Invalid subject id" || msg.includes("Invalid subject id")) {
                            notify(translate("error.fp.AI.subId"), { type: "error" });
                        }
                        else if (msg.includes("Invalid exam id")) {
                            notify(translate("error.fp.AI.examId"), { type: "error" });
                        }
                        else {
                            notify(msg || translate("error.fp.fpAnlysis"), { type: "error" });
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        setIsLoadingFPAI(false);
                        setIsAnalyzing(false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // useEffect(() => { },
    //     [isLoadingFPAI
    //     ])
    // edit
    var handleFinish = function () {
        if (hasUnsavedChanges && !isAnalyzing) {
            setOpenConfirmDialog(true);
        }
        else {
            closeAndReset();
        }
    };
    var closeAndReset = function () {
        setImage(null);
        //redirect to "AI Results"
        setCurrentSubjectSection("AI Results");
        setDummyCompList([{ name: "AI Results" }]);
        refresh();
    };
    var handleClassify = function () { return __awaiter(void 0, void 0, void 0, function () {
        var imgPaths, passData, classificationResult, updatedImgs, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingUpload(true); // Set isLoadingUpload to true at the beginning
                    imgPaths = curRowImgs.map(function (img) { return img.id; });
                    passData = {
                        photos: imgPaths,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, dataProvider.fpClassify(passData)];
                case 2:
                    classificationResult = _a.sent();
                    if (!Array.isArray(classificationResult.data)) return [3 /*break*/, 4];
                    updatedImgs = classificationResult.data.map(function (result) {
                        var img = curRowImgs.find(function (img) { return img.id === result.photos; });
                        if (img) {
                            return __assign(__assign({}, img), { gradable: result.isGradable, right: result.isRight, center: result.isMacular });
                        }
                        return img;
                    });
                    setCurRowImgs(updatedImgs);
                    return [4 /*yield*/, Promise.all(updatedImgs.map(function (img) { return __awaiter(void 0, void 0, void 0, function () {
                            var params;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!img.id) return [3 /*break*/, 2];
                                        params = {
                                            data: {
                                                gradable: img.gradable,
                                                right: img.right,
                                                center: img.center,
                                            },
                                        };
                                        return [4 /*yield*/, dataProvider.fpOneUpdate(img.resource, params, img.id)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 3:
                    _a.sent();
                    updateAnalyzedResultTextCases(updatedImgs, setAnalyzedResultInfo, translate);
                    _a.label = 4;
                case 4:
                    console.log("Classification and updates completed successfully");
                    return [3 /*break*/, 7];
                case 5:
                    error_2 = _a.sent();
                    console.error("Error in classification process:", error_2);
                    if (error_2.message === "Fail to grade images using Convnext Model") {
                        notify(translate('error.fp.aiclassify'), {
                            type: 'error',
                        });
                    }
                    else {
                        // Handle other errors if needed
                        notify('An unexpected error occurred', { type: 'error' });
                    }
                    return [3 /*break*/, 7];
                case 6:
                    setIsLoadingUpload(false); // Set isLoadingUpload to false at the end
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedModifiedCurRowImgs, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingUpload(true);
                    updatedModifiedCurRowImgs = modifiedCurRowImgs;
                    updatedModifiedCurRowImgs.comment = removeDuplicateCommentRows(updatedModifiedCurRowImgs.comment);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    return [4 /*yield*/, updateEyeLabel()];
                case 2:
                    _a.sent();
                    // fp comment update
                    return [4 /*yield*/, Promise.all(updatedModifiedCurRowImgs.comment.map(function (el) {
                            return dataProvider.fpOneUpdate(el.resource, el.params, el.id);
                        }))];
                case 3:
                    // fp comment update
                    _a.sent();
                    // fp (drag/drop) update
                    return [4 /*yield*/, Promise.all(updatedModifiedCurRowImgs.update.map(function (el) {
                            return dataProvider.fpOneUpdate(el.resource, el.params, el.id);
                        }))];
                case 4:
                    // fp (drag/drop) update
                    _a.sent();
                    // fp delete update
                    return [4 /*yield*/, Promise.all(updatedModifiedCurRowImgs.delete.map(function (el) {
                            return dataProvider.fpOneDelete(el.resource, el.id);
                        }))];
                case 5:
                    // fp delete update
                    _a.sent();
                    // exams row update
                    return [4 /*yield*/, Promise.all(modifiedCurrentImgUploadRow.map(function (el) {
                            return dataProvider.updateAttribute(el.resource, el.params, el.subject_id, el.id);
                        }))];
                case 6:
                    // exams row update
                    _a.sent();
                    refresh();
                    setHasUnsavedChanges(false);
                    return [3 /*break*/, 9];
                case 7:
                    err_1 = _a.sent();
                    // TODO: i18n
                    if (err_1 == "HttpError2: Exam not found") {
                        notify(translate('error.fp.examNotFound'), {
                            type: 'error',
                        });
                    }
                    else if (err_1.message.includes("not found")) {
                        notify(translate('error.fp.notFound'), {
                            type: 'error',
                        });
                    }
                    else {
                        notify(translate('error.fp.updateFailed'), {
                            type: 'error',
                        });
                    }
                    return [3 /*break*/, 9];
                case 8:
                    setIsLoadingUpload(false);
                    notify(translate("fp.notify.updated"));
                    refresh();
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    // eye label update
    var updateEyeLabel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var eyeLabel, editParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    eyeLabel = updateAnalyzedResultTextCases(curRowImgs, setAnalyzedResultInfo, translate);
                    editParams = {
                        data: {
                            subject_customId: currentImgUploadRow.subject_customId,
                            eye: eyeLabel !== null && eyeLabel !== void 0 ? eyeLabel : null,
                            ai_model: "FP",
                        },
                    };
                    return [4 /*yield*/, dataProvider.updateAttribute(resource, editParams, currentImgUploadRow.hkid_id, currentImgUploadRow.id)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var AnalyzeDialog = function () { return (_jsx(Dialog, { open: openAnalyzeDialog, onClose: resetAnalyzeDialog, children: _jsx(DialogContent, { children: analyzeDialogStep === "language" ? (_jsxs(Grid, { container: true, spacing: 2, justifyContent: "center", children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { variant: "contained", fullWidth: true, onClick: function () { return handleLanguageSelect("en"); }, style: { marginBottom: "10px" }, children: "English" }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { variant: "contained", fullWidth: true, onClick: function () { return handleLanguageSelect("zh-HK"); }, style: { marginBottom: "10px" }, children: "\u7E41\u9AD4\u4E2D\u6587" }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { variant: "contained", fullWidth: true, onClick: function () { return handleLanguageSelect("zh-CN"); }, children: "\u7B80\u4F53\u4E2D\u6587" }) })] })) : canCreateDetailedReport ? (_jsxs(Grid, { container: true, spacing: 2, justifyContent: "center", children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { variant: "contained", fullWidth: true, onClick: function () { return handleFPAIAnalyze(selectedLanguage, false); }, style: { marginBottom: "10px" }, children: translate("pages.exam.fp.summaryReport") }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { variant: "contained", fullWidth: true, onClick: function () { return handleFPAIAnalyze(selectedLanguage, true); }, style: { marginBottom: "10px" }, children: translate("pages.exam.fp.detailedReport") }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { variant: "outlined", fullWidth: true, onClick: function () { return setAnalyzeDialogStep("language"); }, children: translate("common.back") }) })] })) : null }) })); };
    // Add confirmation dialog for unsaved changes
    var ConfirmDialog = function () { return (_jsx(Dialog, { open: openConfirmDialog, onClose: function () { return setOpenConfirmDialog(false); }, children: _jsxs(DialogContent, { children: [_jsx(Typography, { children: translate('common.unsavedChanges') }), _jsxs(Grid, { container: true, spacing: 2, justifyContent: "center", style: { marginTop: '20px' }, children: [_jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, handleSave()];
                                            case 1:
                                                _a.sent();
                                                closeAndReset();
                                                setOpenConfirmDialog(false);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, children: translate('common.saveAndClose') }) }), _jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", onClick: function () {
                                    closeAndReset();
                                    setOpenConfirmDialog(false);
                                }, children: translate('common.closeWithoutSaving') }) }), _jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", onClick: function () { return setOpenConfirmDialog(false); }, children: translate('common.close') }) })] })] }) })); };
    return (_jsxs(Grid, { item: true, style: styles.container, children: [_jsx(Box, { sx: {
                    backgroundColor: 'warning.main',
                    color: 'warning.contrastText',
                    p: 1,
                    borderRadius: 5,
                    marginLeft: 'auto',
                    fontSize: '0.7em',
                    marginTop: '0.5em'
                }, children: _jsx("strong", { children: translate("fp.saveBeforeUpload") }) }), _jsxs(Grid, { item: true, display: "flex", flexWrap: "wrap", justifyContent: "flex-start", paddingY: 1, gap: 2, children: [_jsx(Grid, { item: true, children: _jsxs(Button, { variant: "contained", disabled: isLoadingUpload, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, handleSave()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, children: [!isLoadingUpload && translate("common.save"), isLoadingUpload && _jsx(CircularProgress, { color: "grey", size: 24 })] }) }), _jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", onClick: function () {
                                handleFinish();
                            }, children: translate("common.leave") }) }), _jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", onClick: function () { return handleClassify(); }, children: translate("common.classify") }) }), _jsx(Grid, { item: true, children: _jsxs(Button, { variant: "contained", disabled: (((analyzedResultInfo === null || analyzedResultInfo === void 0 ? void 0 : analyzedResultInfo.type) == "none" ||
                                (analyzedResultInfo === null || analyzedResultInfo === void 0 ? void 0 : analyzedResultInfo.type) == "toomuch" ||
                                isLoadingFPAI) || (parseInt(gens) <= 0 || !gens))
                                ? true
                                : false, onClick: function () { return setOpenAnalyzeDialog(true); }, children: [!isLoadingFPAI && translate("common.analyze"), isLoadingFPAI && _jsx(CircularProgress, { color: "inherit", size: 24 })] }) }), _jsx(Tooltip, { title: _jsx(_Fragment, { children: analyzeTips.map(function (el, idx) {
                                return _jsx(Typography, { children: el });
                            }) }), placement: "top", children: _jsx(IconButton, { sx: { padding: 0 }, children: _jsx(InfoIcon, {}) }) })] }), isLoadingUpload && !isLoadingFPAI && (_jsx(Grid, { item: true, xs: 12, children: _jsx(LoadingAnimation, {}) })), image && !isLoadingUpload && (_jsxs(Grid, { item: true, style: styles.containerAfterAnlyze, children: [_jsxs(Typography, { variant: "body2", color: "text.secondary", children: [gens, translate("pages.membership.fields.plans.genLeft")] }), _jsxs(Grid, { item: true, style: __assign(__assign({}, styles.anaylzedText), { backgroundColor: analyzedResultInfo === null || analyzedResultInfo === void 0 ? void 0 : analyzedResultInfo.bgColor }), marginY: 1, children: [analyzedResultInfoIcon && (_jsx(Typography, { paddingTop: "3px", paddingRight: "5px", children: analyzedResultInfoIcon })), _jsx(Typography, { className: "small-text normal-bold", children: analyzedResultInfo === null || analyzedResultInfo === void 0 ? void 0 : analyzedResultInfo.text })] }), _jsx(DndContext, { onDragEnd: handleDragEnd, onDragStart: handleDragStart, children: _jsxs(Grid, { item: true, style: { width: "100%", boxShadow: "0 0 2px 0.1px gray" }, children: [_jsxs(Grid, { container: true, children: [_jsx(Grid, { container: true, xs: 12, children: _jsx(Grid, { className: "small-text large-bold", xs: 12, style: styles.withBorder, justifyContent: "center", children: translate("fp.gradableFp") }) }), _jsxs(Grid, { container: true, xs: 12, children: [_jsx(Grid, { className: "small-text large-bold", xs: 12, sm: 12, md: 2, style: styles.titleWithBorder, justifyContent: "center", children: translate("fp.macula_centered") }), _jsxs(Grid, { container: true, style: __assign({}, styles.droppableOuterGrid), xs: 12, sm: 12, md: 5, children: [_jsx(Grid, { className: "small-text large-bold", xs: 12, style: __assign(__assign({}, styles.droppableGrid), styles.withBorder), justifyContent: "center", children: _jsx(Droppable, { id: "center-right-eye", existArr: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.filter(function (el) { return el.gradable && el.center && el.right; }), children: translate("fp.right_eye") }) }), _jsx("div", { style: __assign(__assign({}, styles.withBorder), { backgroundColor: "", display: "flex", flexWrap: "wrap", justifyContent: "start" }), children: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.map(function (el, idx) {
                                                                if (el.gradable && el.center && el.right) {
                                                                    return (_jsx(Grid, { xs: 12, pading: 1, margin: 1, children: _jsx(GradableImageGrid, { comment: el.comment, id: el.id, imgName: el.original_name, eyeType: el.right ? "right" : "left", image: el === null || el === void 0 ? void 0 : el.img, handleOpenImage: handleOpenImage, idx: idx, handelImageGrid: handelImageGrid, isDragging: isDragging }) }, "gradable".concat(idx)));
                                                                }
                                                            }) })] }), _jsxs(Grid, { item: true, xs: 12, sm: 12, md: 5, style: __assign(__assign({}, styles.droppableOuterGrid), { backgroundColor: "" }), children: [_jsx(Grid, { className: "small-text large-bold", xs: 12, style: __assign(__assign({}, styles.droppableGrid), styles.withBorder), justifyContent: "center", children: _jsx(Droppable, { id: "center-left-eye", existArr: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.filter(function (el) { return el.gradable && el.center && !el.right; }), children: translate("fp.left_eye") }) }), _jsx("div", { style: __assign(__assign({}, styles.withBorder), { display: "flex", flexWrap: "wrap", justifyContent: "start", backgroundColor: "" }), children: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.map(function (el, idx) {
                                                                if (el.gradable && el.center && !el.right) {
                                                                    return (_jsx(Grid, { xs: 12, pading: 1, margin: 1, children: _jsx(GradableImageGrid, { comment: el.comment, id: el.id, imgName: el.original_name, eyeType: el.right ? "right" : "left", image: el === null || el === void 0 ? void 0 : el.img, handleOpenImage: handleOpenImage, idx: idx, handelImageGrid: handelImageGrid, isDragging: isDragging }) }, "gradable".concat(idx)));
                                                                }
                                                            }) })] })] }), _jsxs(Grid, { container: true, xs: 12, children: [_jsx(Grid, { className: "small-text large-bold", xs: 12, sm: 12, md: 2, style: styles.titleWithBorder, justifyContent: "center", children: translate("fp.disc_centered") }), _jsxs(Grid, { item: true, xs: 12, sm: 12, md: 5, style: __assign(__assign({}, styles.droppableOuterGrid), { backgroundColor: "" }), children: [_jsx(Grid, { className: "small-text large-bold", xs: 12, style: __assign(__assign({}, styles.droppableGrid), styles.withBorder), justifyContent: "center", children: _jsx(Droppable, { id: "not-center-right-eye", existArr: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.filter(function (el) { return el.gradable && !el.center && el.right; }), children: translate("fp.right_eye") }) }), _jsx("div", { style: __assign(__assign({}, styles.withBorder), { backgroundColor: "", display: "flex", flexWrap: "wrap", justifyContent: "start" }), children: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.map(function (el, idx) {
                                                                if (el.gradable && !el.center && el.right) {
                                                                    return (_jsx(Grid, { xs: 12, pading: 1, margin: 1, children: _jsx(GradableImageGrid, { comment: el.comment, id: el.id, imgName: el.original_name, eyeType: el.right ? "right" : "left", image: el === null || el === void 0 ? void 0 : el.img, handleOpenImage: handleOpenImage, idx: idx, handelImageGrid: handelImageGrid, isDragging: isDragging }) }, "gradable".concat(idx)));
                                                                }
                                                            }) })] }), _jsxs(Grid, { item: true, xs: 12, sm: 12, md: 5, style: __assign(__assign({}, styles.droppableOuterGrid), { backgroundColor: "" }), children: [_jsx(Grid, { className: "small-text large-bold", xs: 12, style: __assign(__assign({}, styles.droppableGrid), styles.withBorder), justifyContent: "center", children: _jsx(Droppable, { id: "not-center-left-eye", existArr: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.filter(function (el) { return el.gradable && !el.center && !el.right; }), children: translate("fp.left_eye") }) }), _jsx("div", { style: __assign(__assign({}, styles.withBorder), { backgroundColor: "", display: "flex", flexWrap: "wrap", justifyContent: "start" }), children: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.map(function (el, idx) {
                                                                if (el.gradable && !el.center && !el.right) {
                                                                    return (_jsx(Grid, { xs: 12, pading: 1, margin: 1, children: _jsx(GradableImageGrid, { comment: el.comment, id: el.id, imgName: el.original_name, eyeType: el.right ? "right" : "left", image: el === null || el === void 0 ? void 0 : el.img, handleOpenImage: handleOpenImage, idx: idx, handelImageGrid: handelImageGrid, isDragging: isDragging }) }, "gradable".concat(idx)));
                                                                }
                                                            }) })] })] })] }), _jsxs(Grid, { item: true, display: "flex", flexWrap: "wrap", 
                                    // alignItems="stretch" style={{ backgroundColor: "white", width: "100%" }}
                                    style: __assign(__assign({}, styles.droppableGrid), { backgroundColor: "" }), children: [_jsx(Grid, { className: "small-text large-bold", xs: 12, justifyContent: "stretch", style: __assign(__assign({}, styles.withBorder), { backgroundColor: "#ffd1d1" }), padding: 0.5, children: _jsx(Droppable, { id: "ungradable", existArr: curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.filter(function (el) { return !el.gradable; }), children: translate("fp.ungradableFp") }) }), curRowImgs === null || curRowImgs === void 0 ? void 0 : curRowImgs.map(function (el, idx) {
                                            var _a;
                                            if (!el.gradable) {
                                                return (_jsx(Grid, { xs: 12, sm: 6, md: 4, children: _jsx(UngradableImageGrid, { id: el.id, comment: (_a = el === null || el === void 0 ? void 0 : el.comment) !== null && _a !== void 0 ? _a : "", idx: idx, imgName: el.original_name, handelImageGrid: handelImageGrid, image: el === null || el === void 0 ? void 0 : el.img, isDragging: isDragging }) }, "ungradable".concat(idx)));
                                            }
                                        })] })] }) })] })), openImage && (_jsx(Grid, { item: true, style: { width: "300px", height: "300px" }, children: _jsxs(Dialog, { style: {}, open: openImage, TransitionComponent: Transition, onClose: handleCloseImage, keepMounted: true, children: [_jsx(dialog.header, { title: "Gradable image", handleClose: handleCloseImage }), _jsx(DialogContent, { className: popupStyles.dialogContent, children: _jsx(SecureImage, { style: { maxWidth: "100%", height: "auto", width: "500px" }, src: openImageURL, alt: "Gradable image" }) })] }) })), _jsx(AnalyzeDialog, {}), _jsx(ConfirmDialog, {})] }));
};
export default FPComp;
